{
  "Can i translate this ?": "Can i translate this ?",
  "Accounts": "Accounts",
  "Site settings": "Site settings",
  "Language": "Language",
  "Enable Marmaid": "Enable Marmaid",
  "Enable Blur": "Enable Blur",
  "Enable Animations": "Enable Animations",
  "Personal information": "Personal information",
  "NO": "NO",
  "YES": "YES",
  "General": "General",
  "Profile": "Profile",
  "Notifications": "Notifications",
  "Identity": "Identity",
  "Tokens": "Tokens",
  "Instances": "Instances",
  "Domains": "Domains",
  "Sessions": "Sessions",
  "My Sessions": "My Sessions",
  "No projects": "No projects",
  "Create project": "Create project",
  "Projects": "Projects",
  "Project name": "Project name",
  "Project description": "Project description",
  "Select team": "Select team",
  "Set unique description for project": "Set unique description for project",
  "Please fill out this field.": "Please fill out this field.",
  "Create": "Create",
  "OwnedBy": "OwnedBy",
  "Open": "Open",
  "Settings": "Settings",
  "Apps": "Apps",
  "Logout": "Logout",
  "Admin": "Admin",
  "Iot": "Iot",
  "Name": "Name",
  "Email": "Email",
  "You have being mentioned inside": "You have being mentioned inside",
  "from project": "from project",
  "by": "by",
  "You have being invited as member inside project": "You have being invited as member inside project",
  "to build awesome things": "to build awesome things"
}